
<template>
  <div class="duration-input">
    <input v-model="minutes" v-on:keyup="onKeyUp" class="duration-input" placeholder="Minutes" type="number">
    <span class="duration-input-separation">:</span>
    <input v-model="seconds" v-on:keyup="onKeyUp" class="duration-input" placeholder="Seconds" type="number" min="0" max="59">
  </div>
</template>

<script>
  export default {
    props: ['originalValue'],
    data() {
      return {
        minutes: this.originalValue ? this.getTime(this.originalValue).minutes : null,
        seconds: this.originalValue ? this.getTime(this.originalValue).seconds : null
      }
    },
    methods: {
      getTime(time) {
        const totalSeconds = Math.trunc((time || 0) / 1000);
        const minutes = Math.trunc(totalSeconds / 60);
        const seconds = Math.trunc((totalSeconds % 60));

        return {
          minutes,
          seconds,
        }
      },
      onKeyUp() {
        const minToMilli = parseInt(this.minutes * 60000);
        const secToMilli = parseInt(this.seconds * 1000);
        const milli = minToMilli + secToMilli;

        this.$emit('onValueChanged', milli);
      }
    }
  }
</script>

<style lang="scss">
  .duration-input {
    display: flex;
    align-items: center;
    width: 100%;

    &-separation {
      margin: 0 8px;
      padding: 6px 0 10px;
      line-height: 1;
    }
  }
</style>
